module.exports = __webpack_public_path__ + "img/drink_sprite.42b2e2a4.png";